import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { CSSProperties } from "@material-ui/styles";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TablePagination from "@saleor/components/TablePagination";
import { maybe } from "@saleor/misc";
import { ListProps } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  theme => {
    const overflowing: CSSProperties = {
      overflow: "hidden",
      textOverflow: "ellipsis"
    };
    return {
      clickRow: {
        cursor: "pointer"
      },
      colMedium: {
        overflowing,
        width: "9em",
        [theme.breakpoints.down("md")]: {
          width: "auto"
        }
      },
      colNarrow: {
        overflowing,
        width: "8em",
        [theme.breakpoints.down("md")]: {
          width: "auto"
        }
      },
      colRow: {
        "& th": {
          fontWeight: 600 as 600,
          paddingBottom: theme.spacing(1),
          paddingTop: theme.spacing(1)
        }
      },
      colWide: {
        overflowing,
        width: "12em",
        [theme.breakpoints.down("md")]: {
          width: "auto"
        }
      },
      table: {
        "& td": {
          fontSize: "15px"
        },
        "& th": {
          fontSize: "15px"
        },
        tableLayout: "fixed"
      }
    };
  },
  { name: "PayoutsList" }
);

interface GrabExpressListProp extends ListProps {
  orders: any;
}

const GrabExpressList: React.FC<GrabExpressListProp> = ({
  orders,
  onNextPage,
  onPreviousPage,
  onUpdateListSettings,
  pageInfo,
  settings,
  disabled
}) => {
  const colNum = 5;
  const classes = useStyles({});

  const ordersData = orders?.grabExpress?.edges.map(order => order.node);

  return (
    <>
      <ResponsiveTable className={classes.table}>
        <TableHead>
          <TableCellHeader>
            <FormattedMessage defaultMessage="Mall" />
          </TableCellHeader>
          <TableCellHeader>
            <FormattedMessage defaultMessage="Account User" />
          </TableCellHeader>
          <TableCellHeader>
            <FormattedMessage defaultMessage="Order Code" />
          </TableCellHeader>
          <TableCellHeader>
            <FormattedMessage defaultMessage="Grab Reference Number" />
          </TableCellHeader>
          <TableCellHeader>
            <FormattedMessage defaultMessage="Grab Status" />
          </TableCellHeader>
        </TableHead>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={colNum}
              settings={settings}
              hasNextPage={
                pageInfo && !disabled ? pageInfo.hasNextPage : undefined
              }
              onNextPage={onNextPage}
              onUpdateListSettings={onUpdateListSettings}
              hasPreviousPage={
                pageInfo && !disabled ? pageInfo.hasPreviousPage : undefined
              }
              onPreviousPage={onPreviousPage}
            />
          </TableRow>
        </TableFooter>

        <TableBody>
          {maybe(
            () =>
              ordersData?.map((order, index) => (
                <TableRow key={order ? order.id : `skeleton${index}`}>
                  <TableCell id={`GrabExpressMallNameRow${index}`}>
                    {maybe(() => order?.mall_name, <Skeleton />)}
                  </TableCell>
                  <TableCell id={`GrabExpressAccountNameRow${index}`}>
                    {maybe(
                      () => order.ops_firstname + " " + order.ops_lastname
                    )}
                  </TableCell>
                  <TableCell id={`GrabExpressOrderCodeRow${index}`}>
                    {maybe(() => order?.order_code, <Skeleton />)}
                  </TableCell>
                  <TableCell id={`GrabExpressMallNameRow${index}`}>
                    {maybe(() => order?.reference_no, <Skeleton />)}
                  </TableCell>
                  <TableCell id={`GrabExpressDeliveryStatusRow${index}`}>
                    {maybe(() => order?.delivery_status, <Skeleton />)}
                  </TableCell>
                </TableRow>
              )),
            <TableRow>
              <TableCell colSpan={colNum}>
                <FormattedMessage defaultMessage="No orders found" />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </ResponsiveTable>
    </>
  );
};

export default GrabExpressList;
